import { Document } from '../../jurisdiction/jurisdiction.domain';
import { GridApplicationDocumentTypes } from './enums/grid-application-document-types.enum';

export class PhotovoltaicModule {
  constructor() {
    this.data_sheet = new Document(GridApplicationDocumentTypes.PhotovoltaicDataSheet);
    this.foto_proof_photovoltaic_modules = [new Document(GridApplicationDocumentTypes.FotoProofPhotovoltaicModules)];
  }

  id: number;
  manufacturer: string;
  type: string;
  identical_modules: number;
  power_single_pv_module: number;
  data_sheet: Document;
  foto_proof_photovoltaic_modules: Document[];
}
